import dynamic from "next/dynamic";
import SVG from "react-inlinesvg";
//import Link from "next/link";
import { useState, useRef, useEffect } from "react";
import { RWebShare } from "react-web-share";
import { Swiper, SwiperSlide } from "swiper/react";
import { convertToISO8601 } from "@/utils/dateTimeFormat";
import styles from "./shortsDetail.module.scss";
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const NewsArticleSchema = dynamic(() =>
  import("@/component/SeoTags/NewsArticleSchema")
);
const VideoObjectSchema = dynamic(() =>
  import("@/component/SeoTags/VideoObjectSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
import "swiper/css";
import defaultAuthor from "@/constants/defaultAuthor";
import { decodeHtmlEntities } from "@/utils/stringHelper";
import GTMScript from "@/component/Ads/GTMScript";
import sendGAEvent from "@/utils/gaEvent";

const JWPlayer = dynamic(() => import("@jwplayer/jwplayer-react"), {
  ssr: false,
});
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

const Index = ({ shortVideoData }) => {
  const prepareVideoList = (shortVideoData) => {
    let firstItem = {
      amp_url: shortVideoData?.seo_detail?.amp_url ?? "",
      canonical_url: shortVideoData?.seo_detail?.canonical_url ?? "",
      category_name: shortVideoData?.category_detail?.[0].title ?? "",
      content_type: "short_video",
      datetime_created: shortVideoData?.datetime_created ?? "",
      datetime_published: shortVideoData?.datetime_published ?? "",
      duration: shortVideoData?.duration ?? "",
      image_small: shortVideoData?.image_main ?? "",
      image_small_alt_text: shortVideoData?.image_main_alt_text ?? "",
      image_vertical: shortVideoData?.image_vertical ?? "",
      m3u8_url: shortVideoData?.hls_url[0].video_url ?? "",
      mp4_url: shortVideoData?.mp4_url[0].video_url ?? "",
      nid: shortVideoData.id ?? "",
      seo_detail: shortVideoData?.seo_detail ?? {},
      title: shortVideoData?.title ?? "",
    };

    return [firstItem, ...shortVideoData?.Prev_videos] ?? [];
  };
  const shortsVideoListDataData = prepareVideoList(shortVideoData);
  const swiperRef = useRef(null);
  // console.log("Shorts data ", shortVideoData);

  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  useEffect(() => {
    // destroy all prev players
    const allPlayers = document.querySelectorAll(".jwplayer");
    allPlayers.forEach((player) => {
      const playerInstance = player.jwplayer;
      if (playerInstance) {
        playerInstance.remove();
      }
    });
  }, []);

  const handlePrevClick = (calledFromSwiperEvent = false) => {
    if (window && window.jwplayer) {
      setCurrentVideoIndex(currentVideoIndex - 1);
      if (swiperRef.current && swiperRef.current.swiper) {
        if (!calledFromSwiperEvent) {
          swiperRef.current.swiper.slidePrev();
        }
        setIsPlaying(true);
        if (swiperRef.current.swiper.activeIndex >= 0) {
          window
            .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex + 1}`)
            .stop();
        }
        window
          .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex}`)
          .play();
        window
          .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex}`)
          .setMute(isMuted);
      }
      let websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      sendGAEvent({
        eventName: "page_view",
        pageTitle: shortsVideoListDataData[currentVideoIndex]?.title,
        pageLocation:
          websiteUrl +
          shortsVideoListDataData[currentVideoIndex]?.canonical_url,
      });
      window.history.pushState(
        {},
        null,
        shortsVideoListDataData[currentVideoIndex]?.canonical_url
      );
    }
  };

  const handleNextClick = (calledFromSwiperEvent = false) => {
    if (window && window.jwplayer) {
      setCurrentVideoIndex(currentVideoIndex + 1);
      if (swiperRef.current && swiperRef.current.swiper) {
        if (!calledFromSwiperEvent) {
          swiperRef.current.swiper.slideNext();
        }
        setIsPlaying(true);
        if (
          swiperRef.current.swiper.activeIndex <=
          shortsVideoListDataData?.length - 1
        ) {
          window
            .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex - 1}`)
            .stop();
        }
        window
          .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex}`)
          .play();
        window
          .jwplayer(`jw-player-${swiperRef.current.swiper.activeIndex}`)
          .setMute(isMuted);
      }
      let websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      sendGAEvent({
        eventName: "page_view",
        pageTitle: shortsVideoListDataData[currentVideoIndex]?.title,
        pageLocation:
          websiteUrl +
          shortsVideoListDataData[currentVideoIndex]?.canonical_url,
      });
      window.history.pushState(
        {},
        "",
        shortsVideoListDataData[currentVideoIndex]?.canonical_url
      );
    }
  };

  const handleMuteUnMuteClick = () => {
    if (window && window.jwplayer) {
      setIsMuted(!isMuted);
      if (swiperRef.current && swiperRef.current.swiper) {
        const allPlayers = document.querySelectorAll(".jwplayer");
        // console.log("swiperRef.current.swiper.activeIndex", swiperRef.current.swiper.activeIndex, allPlayers);
        allPlayers.forEach((player, index) => {
          const playerInstance = player;
          if (playerInstance) {
            if (
              playerInstance.id ===
              `jw-player-${swiperRef.current.swiper.activeIndex}`
            ) {
              if (!isMuted) {
                window.jwplayer(playerInstance.id).setMute(true);
              } else {
                window.jwplayer(playerInstance.id).setMute(false);
              }
            } else {
              window.jwplayer(playerInstance.id).setMute(false);
            }
          }
        });
      }
    }
  };

  const handlePlayPauseClick = () => {
    if (window && window.jwplayer) {
      setIsPlaying(!isPlaying);
      if (swiperRef.current && swiperRef.current.swiper) {
        const allPlayers = document.querySelectorAll(".jwplayer");
        allPlayers.forEach((player, index) => {
          const playerInstance = player;
          if (playerInstance) {
            if (
              playerInstance.id ===
              `jw-player-${swiperRef.current.swiper.activeIndex}`
            ) {
              if (!isPlaying) {
                window.jwplayer(playerInstance.id).play();
                window.jwplayer(playerInstance.id).setMute(isMuted);
              } else {
                window.jwplayer(playerInstance.id).pause();
                // window.jwplayer(playerInstance.id).setMute(true);
              }
            } else {
              window.jwplayer(playerInstance.id).pause();
              // window.jwplayer(playerInstance.id).setMute(true);
            }
          }
        });
      }
    }
  };
  // console.log("shortVideoData", shortVideoData);
  return (
    <section>
      <HeadTag
        title={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_title ??
          ""
        }
        description={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail
            ?.meta_description ?? ""
        }
        image={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.og_image ?? ""
        }
        keywords={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_keyword
        }
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          shortsVideoListDataData[currentVideoIndex]?.canonical_url ?? ""
        }
        // ampUrl={
        //   process.env.NEXT_PUBLIC_WEBSITE_URL +
        //     shortsVideoListDataData[currentVideoIndex]?.canonical_url ?? ""
        // }
        showMaxImagePreview={true}
        articlePublishedTime={convertToISO8601(
          shortsVideoListDataData[currentVideoIndex]?.datetime_published
        )}
        articleModifiedTime={convertToISO8601(
          shortsVideoListDataData[currentVideoIndex]?.datetime_published
        )}
        lcpImage={shortsVideoListDataData[currentVideoIndex]?.image_small}
      />
      <GTMScript />

      <WebpageSchema
        title={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_title ??
          ""
        }
        description={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail
            ?.meta_description ?? ""
        }
        keywords={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_keyword
        }
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          shortsVideoListDataData[currentVideoIndex]?.canonical_url ?? ""
        }
      />
      <BreadcrumbSchema breadcrumbList={shortVideoData?.category_detail} />
      <NewsArticleSchema
        title={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_title
        }
        description={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail
            ?.meta_description
        }
        image={shortsVideoListDataData[currentVideoIndex]?.seo_detail?.og_image}
        keywords={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_keyword
        }
        canonical_url={
          shortsVideoListDataData[currentVideoIndex]?.seo_detail?.canonical_url
        }
        publishedAt={convertToISO8601(
          shortsVideoListDataData[currentVideoIndex]?.datetime_published
        )}
        modifiedAt={convertToISO8601(
          shortsVideoListDataData[currentVideoIndex]?.datetime_updated
        )}
        createdAt={convertToISO8601(
          shortsVideoListDataData[currentVideoIndex]?.datetime_created
        )}
        authorName={
          shortVideoData?.author && shortVideoData?.author?.[0]
            ? shortVideoData?.author?.[0]?.title
            : defaultAuthor?.title
        }
        authorCanonicalUrl={
          shortVideoData?.author && shortVideoData?.author?.[0]
            ? shortVideoData?.author?.[0]?.canonical_url
            : defaultAuthor.canonical_url
        }
      />
      {shortVideoData?.type === "short_video" && (
        <VideoObjectSchema
          title={
            shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_title
          }
          description={
            shortsVideoListDataData[currentVideoIndex]?.seo_detail
              ?.meta_description
          }
          image={
            shortsVideoListDataData[currentVideoIndex]?.seo_detail?.og_image
          }
          keywords={
            shortsVideoListDataData[currentVideoIndex]?.seo_detail?.meta_keyword
          }
          canonical_url={
            shortsVideoListDataData[currentVideoIndex]?.seo_detail
              ?.canonical_url
          }
          publishedAt={convertToISO8601(
            shortsVideoListDataData[currentVideoIndex]?.datetime_published
          )}
          modifiedAt={convertToISO8601(
            shortsVideoListDataData[currentVideoIndex]?.datetime_updated
          )}
          authorName={
            shortVideoData?.author && shortVideoData?.author?.[0]
              ? shortVideoData?.author[0]?.title
              : defaultAuthor?.title
          }
          authorCanonicalUrl={
            shortVideoData?.author && shortVideoData?.author?.[0]
              ? shortVideoData?.author[0]?.canonical_url
              : defaultAuthor?.canonical_url
          }
          videoUrl={shortsVideoListDataData[currentVideoIndex]?.m3u8_url ?? ""}
          videoDuration={shortsVideoListDataData[currentVideoIndex]?.duration}
        />
      )}
      {/* h-[100svh] */}
      <h1
        style={{ display: "none" }}
        dangerouslySetInnerHTML={{
          __html: `${shortVideoData?.title ?? ""}`,
        }}
      ></h1>
      <h2
        style={{ display: "none" }}
        dangerouslySetInnerHTML={{
          __html: `${shortVideoData?.description_short ?? ""}`,
        }}
      ></h2>
      <div
        className={`relative overflow-hidden bg-gradient-to-b from-[#333333] to-black ${styles.hScreen}`}
      >
        <div className="flex justify-center items-center h-full">
          {/* JW Player Container */}
          <div className={`${styles.jwpContainer}`}>
            <div
              className="relative w-full h-[96%] top-2"
              style={{ borderRadius: "100px" }}
            >
              <Swiper
                ref={swiperRef}
                direction="vertical"
                slidesPerView={1}
                spaceBetween={0}
                allowTouchMove={true}
                observer={true}
                observeParents={true}
                onSlideChange={(swiper) => {
                  if (swiper.activeIndex > swiper.previousIndex) {
                    handleNextClick(true);
                  } else if (swiper.activeIndex < swiper.previousIndex) {
                    handlePrevClick(true);
                  }
                }}
                // onSwiper={(swiper) => {
                //   // console.log("swiper", swiper);
                //   setIsPlaying(true);
                // }} 
                className="w-full !h-[96%] top-3"
              >
                {shortsVideoListDataData?.map((video, index) => (
                  <SwiperSlide key={index} className="!flex">
                    <JWPlayer
                      key={`jw-player-${index}`}
                      id={`jw-player-${index}`}
                      library={`https://cdn.jwplayer.com/libraries/${process.env.NEXT_PUBLIC_JW_VERTICAL_PLAYER_ID}.js`}
                      playlist={[
                        {
                          file: video.m3u8_url ?? "",
                          image: video.image_vertical ?? "",
                        },
                      ]}
                      // onReady={(e) => {
                      //   // console.log("onReady", e);
                      //   if (index === 0) {
                      //     e.jwplayer.play();
                      //     e.jwplayer.mute = isMuted;
                      //   }
                      // }}
                      onClick={(e) => {
                        // console.log("onClick", e);
                        handlePlayPauseClick();
                      }}
                      config={{
                        autoStart: true,
                        pipIcon: false,
                        generateSEOMetadata: true,
                        fullscreenOrientationLock: "none",
                        controls: false,
                        mute: true,
                        responsive: false,
                        // aspectratio: "9:16",
                        stretching: "exactfit",
                        // mute: isMuted,
                        // play: isPlaying,
                        // pause: !isPlaying,
                      }}
                    />
                    <div className="absolute top-2 w-full text-stone-600">
                      <a href="/short-videos">
                        <SVG
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/leftArrow.svg"
                          className="w-8 h-8 absolute top-4 left-4 text-white"
                        />
                      </a>
                    </div>
                    {!isPlaying && (
                      <button
                        onClick={() => {
                          handlePlayPauseClick();
                        }}
                      >
                        <span className="text-primary">
                          <SVG
                            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media.svg"
                            className="w-20 h-20 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                          />
                        </span>
                      </button>
                    )}

                    <div
                      className="absolute bottom-0 w-full pt-20"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
                      }}
                    >
                      {/* Video Title */}
                      <div
                        className="items-center text-white text-2xl mb-8 w-[90%] pl-4"
                        dangerouslySetInnerHTML={{
                          __html: `${video.title ?? ""}`,
                        }}
                      />

                      {/* Bottom buttons */}
                      <div className="pb-4 flex w-full">
                        <button
                          onClick={() => {
                            handleMuteUnMuteClick();
                          }}
                          className="text-white w-1/3 flex justify-center"
                        >
                          {isMuted ? (
                            <SVG
                              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/mute.svg"
                              className="w-8 h-8"
                            />
                          ) : (
                            <SVG
                              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/speaker.svg"
                              className="w-8 h-8"
                            />
                          )}
                        </button>
                        <a
                          href={`https://wa.me/?text=${encodeURIComponent(
                            process.env.NEXT_PUBLIC_WEBSITE_URL +
                            video?.seo_detail?.canonical_url ?? ""
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white w-1/3 flex justify-center"
                          aria-label="Share on WhatsApp"
                        >
                          <button className="text-white w-1/3 flex justify-center">
                            <SVG
                              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/whatsapp-outline.svg"
                              className="w-8 h-8"
                            />
                          </button>
                        </a>
                        <RWebShare
                          data={{
                            text: decodeHtmlEntities(video.title),
                            url:
                              process.env.NEXT_PUBLIC_WEBSITE_URL +
                              video?.seo_detail?.canonical_url ?? "",
                            title: decodeHtmlEntities(video.title),
                          }}
                          sites={[
                            "copy",
                            "facebook",
                            "twitter",
                            "whatsapp",
                            "mail",
                            "linkedin",
                            "reddit",
                          ]}
                        >
                          <button className="text-white w-1/3 flex justify-center">
                            <SVG
                              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/share.svg"
                              className="w-8 h-8"
                            />
                          </button>
                        </RWebShare>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {/* Side navigation buttons - hidden on mobile */}
          <div className="hidden sm:flex flex-col justify-center space-y-2 pl-4 ">
            <button
              disabled={currentVideoIndex === 0}
              onClick={() => {
                handlePrevClick();
              }}
              className={
                currentVideoIndex === 0
                  ? "text-[#707070] my-4 border-[#707070] border-2 rounded-full p-3 bg-neutral-900 opacity-75 cursor-not-allowed"
                  : "text-white my-4 border-[#707070] border-2 rounded-full p-3 bg-neutral-900 hover:bg-yellow-950"
              }
            >
              <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up.svg" className="w-6 h-6" />
            </button>
            <button
              disabled={
                shortsVideoListDataData?.length > 0 &&
                currentVideoIndex === shortsVideoListDataData?.length - 1
              }
              onClick={() => {
                handleNextClick();
              }}
              className={
                shortsVideoListDataData?.length > 0 &&
                  currentVideoIndex === shortsVideoListDataData?.length - 1
                  ? "text-[#707070] my-4 border-[#707070] border-2 rounded-full p-3 bg-neutral-900 opacity-75 cursor-not-allowed"
                  : "text-white my-4 border-[#707070] border-2 rounded-full p-3 bg-neutral-900 hover:bg-yellow-950"
              }
            >
              <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/down.svg" className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
